import { render, staticRenderFns } from "./WizardStepOrigin.vue?vue&type=template&id=c2eaaf4e&scoped=true"
import script from "./WizardStepOrigin.vue?vue&type=script&lang=js"
export * from "./WizardStepOrigin.vue?vue&type=script&lang=js"
import style0 from "./WizardStepOrigin.vue?vue&type=style&index=0&id=c2eaaf4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2eaaf4e",
  null
  
)

export default component.exports